import React from 'react';
import { Component } from 'react';
import { menuIcon } from './icons';

interface PopupMenuState {
    isOpen: boolean;
}

export class PopupMenu extends Component<{ title?: string, children?: any }, PopupMenuState> {
    state = { isOpen: false };

    setClosed() {
        this.setState({ isOpen: false });
    }

    setOpen() {
        this.setState({ isOpen: true });
    }

    render = () => <>
<button title={this.props.title} className="inlineEditButton optionsButton" onClick={e => { this.setOpen(); e.stopPropagation(); }}>
    {menuIcon}
</button>
<aside
    className="popupmenu"
    onMouseLeave={() => this.setClosed()}>
    <article
        className={this.state.isOpen
                    ? 'popupmenu__article--open'
                    : 'popupmenu__article--closed'}>
        {this.props.children}
    </article>
</aside>
</>
}
